import * as React from 'react';

import {colors} from '../../colors/colors';

import styles from './orbs.module.css';

type OrbConfig = {
    top: number;
    left: number;
};

type Props = {
    children: React.ReactNode;
    config?: Array<OrbConfig>;
};

export function Orbs(props: Props) {
    const {config} = props;

    const orbElements = React.useMemo(() => {
        if (!config) return [];

        return config.map((orbConfig, index) => {
            const style = {
                top: `${orbConfig.top}%`,
                left: `${orbConfig.left}%`,
                '--noise-offset': `${index * -2}s`,
                '--background-color': index % 2 === 0 ? colors.aiPurplePink : colors.aiPurplePinkMd,
            } as const;

            return (
                <div
                    key={`orb-${orbConfig.top}-${orbConfig.left}`}
                    style={style}
                    className={styles.orb}
                />
            );
        });
    }, [config]);

    return (
        <div className={styles.orbs}>
            <div className={styles.content}>{props.children}</div>
            {orbElements}
        </div>
    );
}
